window.loadThirdPartyScriptWhenReady =
  window.loadThirdPartyScriptWhenReady ||
  function (callback) {
    const runCallback = function () {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(callback, { timeout: 2000 });
        return;
      }

      window.setTimeout(callback, 0);
    };

    if (document.readyState === "complete") {
      runCallback();
      return;
    }

    window.addEventListener("load", runCallback, { once: true });
  };
